import React from 'react'
import styles from './Notification.module.scss'

interface NotificationHeadingProps {
  children: React.ReactNode
}

const NotificationHeading = ({ children }: NotificationHeadingProps) => (
  <strong className={styles.heading}>{children}</strong>
)

export default NotificationHeading
